import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css' // 引入全部样式
import 'amfe-flexible'
import './styles/index.less'

import { getZgTenantByDomain } from './server/home'

Vue.config.productionTip = false

// session数据存储到vuex保存登陆信息
const sessionUserInfo = sessionStorage.getItem('userInfo') || '{}'
//const sessionUserInfo = localStorage.getItem('userInfo') || '{}'
const userInfo = JSON.parse(sessionUserInfo)
const isLogin = sessionUserInfo !== '{}'

store.dispatch('loginAction', {
  userInfo,
  isLogin
})


// 获取租户信息
// https://yezhi-staging.zhidaiyi.com/
// const domain = window.location.hostname === 'localhost'
//   ? 'http://cztest.yeahip.com'
//   : window.location.hostname
const domain = window.location.hostname === 'localhost'
    ? ('localhost:' + window.location.port)
    : window.location.hostname
// const doMainMap = domain.split('.')
// var postDomain = ''
// if (domain.indexOf('zhidaiyi') > -1) {
//   postDomain = doMainMap[0]
// } else {
//   postDomain = doMainMap[1]
// }
getZgTenantByDomain({ domain: domain }).then(res => {
  if (res.success) {
    const companyInfo = res.data
    const tenantId = companyInfo.id
    sessionStorage.setItem('companyInfo', JSON.stringify(companyInfo))
    sessionStorage.setItem('tenantId', companyInfo.id)
    store.dispatch('loginAction', {
      userInfo,
      isLogin,
      companyInfo,
      tenantId
    })

  }
})



Vue.use(Vant) // 全局注册所有组件
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
